export function calculateVaporRetarderCompliance(props: {
    data: {
        LOC2_climate_zone: { value: string }
        Wall9_vapor_retarder_class: { value: string }
        IN3b_frame_wall_insulation_continuous: { value: number }
        Wall2_framing_depth: { value: number }
        Wall10_vented_cladding: { value: string }
        Wall11_sheathing_material: { value: string }
    }
}) {
    const IN3bValue =
        props.data.IN3b_frame_wall_insulation_continuous?.value ?? 0
    const wall2Depth = props.data.Wall2_framing_depth?.value
    const wall10 = props.data.Wall10_vented_cladding?.value
    const wall11 = props.data.Wall11_sheathing_material?.value
    const wall9Class = props.data.Wall9_vapor_retarder_class?.value
    const climateZone = props.data.LOC2_climate_zone?.value

    if (
        [
            '0A',
            '0B',
            '1A',
            '1B',
            '2A',
            '2B',
            '3A',
            '3B',
            '3C',
            '4A',
            '4B',
        ].includes(climateZone)
    ) {
        return 'Not applicable'
    }

    if (wall9Class === 'Class I' || wall9Class === 'Class II') {
        return 'Complies'
    }

    const wall9ClassIIICompliances = [
        { zones: ['4C'], minRValue: 2.5, depth: 4 },
        { zones: ['4C'], minRValue: 3.75, depth: 6 },
        { zones: ['5A', '5B', '5C'], minRValue: 5, depth: 4 },
        { zones: ['5A', '5B', '5C'], minRValue: 7.5, depth: 6 },
        { zones: ['6A', '6B'], minRValue: 7.5, depth: 4 },
        { zones: ['6A', '6B'], minRValue: 11.25, depth: 6 },
        { zones: ['7', '8'], minRValue: 10, depth: 4 },
        { zones: ['7', '8'], minRValue: 15, depth: 6 },
    ]

    const complies = wall9ClassIIICompliances.some(
        ({ zones, minRValue, depth }) => {
            return (
                zones.includes(climateZone) &&
                IN3bValue >= minRValue &&
                Number(wall2Depth) === depth
            )
        },
    )

    if (complies) {
        return 'Complies'
    }

    const wall11Compliances = [
        {
            zones: ['4C', '5A', '5B', '5C'],
            materials: [
                'Not observable',
                'OSB',
                'Plywood',
                'Fiberboard',
                'Gypsum',
                'ZIP',
            ],
        },
        { zones: ['6A', '6B'], materials: ['Fiberboard', 'Gypsum'] },
    ]

    const wall10Complies = wall11Compliances.some(({ zones, materials }) => {
        return (
            zones.includes(climateZone) &&
            wall10 === 'Yes' &&
            materials.includes(wall11)
        )
    })

    if (wall10Complies) {
        return 'Complies'
    }

    if (wall10 === 'Not observable') {
        return 'Not observable'
    }

    return 'Does not comply'
}
